export enum MachinesGroupType {
  YesterdayLogs = "YesterdayLogs",
  LastWeekLogs = "LastWeekLogs",
  LastMonthLogs = "LastMonthLogs",
  PastEntries = "PastEntries",
  WithFlag = "WithFlag",
  WithoutFlag = "WithoutFlag",
}
